<script setup lang="ts">
	import { timeFormat } from '@/utils/format.ts';
	import { useIntervalFn } from '@vueuse/core';
	import { useI18n } from 'vue-i18n';
	import { ref, type Ref } from 'vue';

	const { t } = useI18n();
	const expirationTimer: Ref<number> = ref(3600);

	const { pause, resume, isActive } = useIntervalFn(() => {
		if (expirationTimer.value > 0) expirationTimer.value--;
		else {
			pause();
		}
	}, 1000);

	const resumeExpiration = () => {
		expirationTimer.value = 3600;
		resume();
	};

	defineExpose({ resumeExpiration });
</script>

<template>
	<div v-if="isActive" class="flex flex-row gap-1">
		<p>{{ t('mfa.code_expiration') }}</p>
		<p class="font-bold">{{ timeFormat(expirationTimer) }}</p>
	</div>
	<div v-else>
		<p>{{ t('mfa.code_expired') }}</p>
	</div>
</template>
